if (document.readyState !== 'loading') {
    initWidget();
} else {
    window.addEventListener('DOMContentLoaded', () => {
        initWidget();
    });
}

function initWidget() {
    const navItems = document.querySelectorAll('.ct_navigation .nav-item');

    if (!navItems) {
        return;
    }

    navItems.forEach((navItem) => {
        navItem.addEventListener('mouseenter', handleNavItemHover);
        navItem.addEventListener('mouseleave', handleNavItemLeave);
    });
}

function handleNavItemHover(e) {
    const navItem = e.currentTarget;
    closeDropdowns(navItem);

    if (navItem.classList.contains('dropdown')) {
        navItem.classList.add('show');
        navItem.setAttribute('aria-expanded', 'true');

        const menu = navItem.querySelector('.dropdown-menu');
        if (menu) {
            menu.classList.add('show');
            menu.setAttribute('aria-expanded', 'true');
        }
    }
}

function handleNavItemLeave(e) {
    const navItem = e.currentTarget;
    closeDropdowns(navItem);
}

function closeDropdowns(navItem) {
    // remove previously opened dropdowns
    const dropdowns = navItem.parentElement.querySelectorAll('.dropdown');
    const dropdownMenus = navItem.parentElement.querySelectorAll('.dropdown-menu');

    if (dropdowns) {
        dropdowns.forEach((dropdown) => {
            dropdown.setAttribute('aria-expanded', 'false');
            dropdown.classList.remove('show');
        });
    }

    if (dropdownMenus) {
        dropdownMenus.forEach((menu) => {
            menu.setAttribute('aria-expanded', 'false');
            menu.classList.remove('show');
        });
    }
}
